// This is example of menu item without group for horizontal layout. There will be no children.

// third-party
import { FormattedMessage } from 'react-intl';

// ==============================|| MENU ITEMS - SAMPLE PAGE ||============================== //

const learning = {
  id: 'learning',
  title: <FormattedMessage id="learning" />,
  type: 'group',
  url: '/apprentissage',
};

export default learning;
